import { connect } from 'react-redux';
import withTheme from '@mui/styles/withTheme';
import UserModalMobile from 'components/user/UserModalMobile/UserModalMobile';

import {
    setUserObject,
    setUserResponse,
    setSaveButtonDisabled,
    setOpenUserMobile
} from 'redux/actions/userActions';

import { onSubmit } from 'redux/workers/userWorker';

const mapStateToProps = state => {
    const { UserReducers, FacilityReducers } = state;

    if (UserReducers) {
        return {
            user: UserReducers.user,
            facilityList: FacilityReducers.facilities,
            isModalMobile: UserReducers.isModalMobile,
            errorMessage: UserReducers.userResponse,
            saveButtonDisabled: UserReducers.saveButtonDisabled
        };
    }

    return {};
};

const UserModalMobileContainer = withTheme(
    connect(
        mapStateToProps, {
            onSubmit,
            setSaveButtonDisabled,
            setUserResponse,
            setUserObject,
            setOpenUserMobile
        }
    )(UserModalMobile)
);

export default UserModalMobileContainer;
